import { TextLink, TextLinkProps } from '@dtpk-cc/components';
import { ComponentRef, forwardRef, ForwardRefRenderFunction, MouseEventHandler, useCallback } from 'react';
import { LinkProps, useHref, useLinkClickHandler } from 'react-router-dom';

type RouterTextLinkProps = Omit<LinkProps, 'onClick'> & Omit<TextLinkProps, 'href' | 'target'>;
/*
 * This is en exact rebuild of the react-router-dom's <Link> component.
 * We provide it to be able to use the LPG's <TextLink> component with react-router functionality
 *
 * */

const RouterTextLinkWithRef: ForwardRefRenderFunction<ComponentRef<typeof TextLink>, RouterTextLinkProps> = (
    { onClick, replace = false, reloadDocument, state, target, to, children, ...restProps },
    ref
) => {
    const href = useHref(to);
    const internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
    });

    const handleClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
        (event) => {
            if (onClick) {
                onClick(event);
            }

            if (!event.defaultPrevented && !reloadDocument) {
                internalOnClick(event);
            }
        },
        [onClick, reloadDocument, internalOnClick]
    );

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <TextLink href={href} onClick={handleClick} ref={ref} target={target} {...restProps}>
            {children}
        </TextLink>
    );
};

export const RouterTextLink = forwardRef(RouterTextLinkWithRef);
